/**
 * Capitalise uniquement la première lettre du texte des metafields
 * sans toucher aux unités (L, cm, etc.)
 */
(function() {
  'use strict';
  
  function capitalizeFirst() {
    // Sélectionner toutes les valeurs de metafields (catalogue et page produit)
    const metafieldValues = document.querySelectorAll(
      '.card__metafield-value:not(.card__metafield-value--price), ' +
      '.product__metafield-value:not(.product__metafield--price .product__metafield-value):not(.product__metafield--vendor .product__metafield-value)'
    );
    
    metafieldValues.forEach(element => {
      let text = element.textContent.trim();
      
      if (text && text.length > 0) {
        // Ne capitaliser que si le premier caractère est une lettre minuscule
        if (/^[a-z]/.test(text)) {
          const firstLetter = text.charAt(0).toUpperCase();
          const restOfText = text.slice(1);
          element.textContent = firstLetter + restOfText;
        }
        // Si le texte a déjà une majuscule au début, ne rien faire
      }
    });
  }
  
  // Exécuter au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', capitalizeFirst);
  } else {
    capitalizeFirst();
  }
  
  // Observer les changements du DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(capitalizeFirst, 100);
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();